<template>
  <div class="upload-container">
    <el-button icon='upload' :style="{background:color,borderColor:color}" @click=" dialogVisible=true" type="primary">上传图片
    </el-button>
    <el-dialog :visible.sync="dialogVisible">
      <el-upload class="editor-slide-upload" action="https://upload-z2.qiniup.com" :multiple="true" :show-file-list="true" list-type="picture-card" :on-remove="handleRemove" :on-success="handleSuccess" :before-upload="beforeUpload" :data="formData">
        <el-button size="small" type="primary">点击上传</el-button>
      </el-upload>
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </el-dialog>
  </div>
</template>

<script>
// import { getToken } from 'api/qiniu'
import request from '@/utils/request'

export default {
  name: 'editorSlideUpload',
  props: {
    color: {
      type: String,
      default: '#20a0ff'
    }
  },
  data() {
    return {
      dialogVisible: false,
      baseUrl: 'https://img.nzmai.com.cn/',
      aPicture: [],
      formData: {
        key: '',
        token: ''
      }
    }
  },
  methods: {
    randomName(len) {
      let str = ''
      for (let i = 0; i < len; i = str.length) {
        str += Math.random()
          .toString(36)
          .substr(2)
      }
      return str.substr(0, len) + '_' + Date.now()
    },
    fetchUploadToken() {
      request({
        url: '/upload-token',
        method: 'get'
      })
        .then(res => {
          if (res.status === 0) {
            this.formData.token = res.data.token
          } else {
            this.$message.error('获取上传凭证失败，请联系管理员')
          }
        })
        .catch(err => {
          console.warn(err)
        })
    },

    checkAllSuccess() {
      return this.aPicture.every(item => item.hasSuccess)
    },

    handleSubmit() {
      if (this.checkAllSuccess()) {
        this.$emit(
          'successCBK',
          this.aPicture.map((val, index) => {
            return val.url
          })
        )
        this.aPicture = []
        this.dialogVisible = false
      } else {
        this.$message(
          '请等待所有图片上传成功 或 出现了网络问题，请刷新页面重新上传！'
        )
      }
    },
    handleSuccess(res, file) {
      const uid = file.uid
      for (let i = 0, l = this.aPicture.length; i < l; i++) {
        if (uid === this.aPicture[i].uid) {
          this.aPicture[i].hasSuccess = true
          this.aPicture[i].url = this.baseUrl + res.key
          break
        }
      }
    },
    handleRemove(file) {
      const uid = file.uid
      for (let i = 0, l = this.aPicture.length; i < l; i++) {
        if (uid === this.aPicture[i].uid) {
          this.aPicture.splice(i, 1)
          break
        }
      }
    },
    beforeUpload(file) {
      this.formData.key =
        this.randomName(10) + file.name.replace(/.+(\.\w+)/, '$1')
      this.aPicture.push({
        uid: file.uid,
        hasSuccess: false,
        url: ''
      })
    }
  },
  created() {
    this.fetchUploadToken()
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.upload-container {
  .editor-slide-upload {
    margin-bottom: 20px;
  }
}
</style>
